<template>
    <TooltipOption
        :cypress-id="cypressId"
        :to="to"
        class="dropdown-button-option"
        @click="$emit('click', $event)"
    >
        <slot />
    </TooltipOption>
</template>

<script lang="ts" setup>
import type { RouteLocation } from 'vue-router';
import TooltipOption from './TooltipOption.vue';

type Props = {
    to?: string | RouteLocation | null,
    cypressId?: string | null,
}

withDefaults(defineProps<Props>(), {
    to: null,
    cypressId: null,
});

type Emits = {
    (event: 'click', type: Event): void,
};

defineEmits<Emits>();

</script>

<style lang="scss" scoped>
@import '../../../styles/abstracts/variables';

.dropdown-button-option {
    color: var(--theme-color-text-primary);

    &:hover {
        background-color: var(--theme-color-surface-secondary-default);
    }

    &:first-child:hover {
        border-radius: $border-radius $border-radius 0 0;
    }

    &:last-child:hover {
        border-radius: 0 0 $border-radius $border-radius;
    }

    &:not(:first-child):not(:last-child):hover {
        border-radius: 0;
    }
}
</style>
